import { render } from "./PlaceholderChart.vue?vue&type=template&id=130d5d42&scoped=true"
import script from "./PlaceholderChart.vue?vue&type=script&lang=js"
export * from "./PlaceholderChart.vue?vue&type=script&lang=js"

import "./PlaceholderChart.vue?vue&type=style&index=0&id=130d5d42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130d5d42"]])

export default __exports__